export const enum LocalStorageKeys {
  BET_SLIP_WIDGET = "betslip-widget",
}
export const enum ReactQueryKeys {
  SELECTIONS_ODDS_CHANGES = "selections-odds-changes",
}

export const enum ApiUrls {
  // All Platfroms
  GET_EVENTS = "/services/evapi/event/GetEvents",

  // Not on POS maybe Cashbox?
  GET_BET_SLIP_DATA = "/services/clapi/api/Bet/GetBetSlipDataCL",

  // Online Platforms
  ABORT_BET_CHANGES = "/services/authorization/api/BetMonitoring/Abort",
  DECLINE_BET_CHANGES = "/services/authorization/api/BetMonitoring/Decline",
  PLACE_BET_SPORT = "/services/clapi/api/Bet/placebetsport",
  EXECUTE_ORDER = "/services/clapi/api/bet/executeorder",
  GET_BONUS_RULES = "/services/clapi/api/dynamic/Execute/Sport/GetBonusRules",
  GET_AUTHORIZATION_MESSAGE = "/services/clapi/api/dynamic/execute/Sport/GetAuthorizationMessages",
}

export const enum AuthorizationStatus {
  Waiting = 1, // Waiting for authorization
  Declined = 2, // Authorization declined
  Confirmed = 3, // Authorization confirmed
  Canceled = 4, // Authorization canceled
  Expired = 5, // Authorization expired
}

export const enum PlaceBetStatus {
  Idle = "idle",
  Placing = "placing",
  Timeout = "timeout",
  Authorizing = "authorizing",
  Declined = "declined",
  ConfirmChanges = "confirm-changes",
}

export const enum StateActionTypes {
  SET_SELECTIONS = "SET_SELECTIONS",
  SET_LOADING = "SET_LOADING",
  SET_ERROR = "SET_ERROR",
  SET_MODE = "SET_MODE",
  SET_STAKES = "SET_STAKES",
  RESTORE_STATE = "RESTORE_STATE",
  CHANGE_CULTURE = "CHANGE_CULTURE",
  UPDATE_CONFIG = "UPDATE_CONFIG",
  ACCEPT_ODDS_CHANGES = "ACCEPT_ODDS_CHANGES",
  TOGGLE_ACCEPT_ODDS_CHANGES = "TOGGLE_ACCEPT_ODDS_CHANGES",
  SET_SOURCE = "SET_SOURCE",
  UPDATE_ODDS_CHANGES = "UPDATE_ODDS_CHANGES",
  ADD_SELECTION = "ADD_SELECTION",
  REMOVE_SELECTION = "REMOVE_SELECTION",
  CLEAR_ALL_SELECTIONS = "CLEAR_ALL_SELECTIONS",
  UPDATE_SINGLE_STAKE = "UPDATE_SINGLE_STAKE",
  UPDATE_GLOBAL_STAKE = "UPDATE_GLOBAL_STAKE",
  UPDATE_BET_BUILDER_STATE = "UPDATE_BET_BUILDER_STATE",
  CONFIRM_BET_BUILDER_REMOVAL = "CONFIRM_BET_BUILDER_REMOVAL",
  CANCEL_BET_BUILDER_REMOVAL = "CANCEL_BET_BUILDER_REMOVAL",
  UPDATE_SELECTIONS_FROM_RECOVERY = "UPDATE_SELECTIONS_FROM_RECOVERY",
  SHOW_BB_CONFIRM = "SHOW_BB_CONFIRM",
  ADD_BB_BETS = "ADD_BB_BETS",
  REMOVE_BB_BETS = "REMOVE_BB_BETS",
  CLEAR_ALL_BB_BETS = "CLEAR_ALL_BB_BETS",
  REMOVE_BB_EVENT = "REMOVE_BB_EVENT",
  BB_RECALCULATE = "BB_RECALCULATE",
  BB_SELECTIONS_LIMIT = "BB_SELECTIONS_LIMIT",
  BB_COMBINABLE_LIMIT = "BB_COMBINABLE_LIMIT",
  BETSLIP_SELECTIONS_LIMIT = "BETSLIP_SELECTIONS_LIMIT",
}

export const enum SelectionConditionEnum {
  // Not In Bet Builder Market List
  NotInNormalSelectionsNotInWidget = 1, // add selection
  NotBBInWidget = 2, // widget prompt replace bb
  NotBBInNormalSelections = 3, // Replace selection

  // Bet Builder Market List
  isBBInNormalSelectionsSameMarketSameOddAndNotInWidget = 4, // remove selection
  isBBInNormalSelectionsSameMarketDifferentOddAndNotInWidget = 5, // replace the selection
  isBBInNormalSelectionDifferentMarketNotInWidget = 6, // remove N selection => Create Widget with 2 Selection
  isBBInWidgetSameMarketSameOdd = 7, // Remove from Widget (widget.removeBet)
  isBBInWidgetSameMarketDifferentOdd = 8, // Update in Widget
  isBBInWidgetDifferentMarket = 9, // widget.addBet
}

export const enum BetSlipMode {
  Single = "single",
  Combo = "combo",
  System = "system",
}

export enum EventStatus {
  Prematch = 0,
  Live = 1,
  Closed = 2,
}

export enum OddStatus {
  Active = 0,
  Suspended = 1,
  Closed = 2,
}

export const enum OddMatchConditionEnum {
  MatchedActive = 1, // odd found in the update payload and still active
  MatchedSuspended = 2, // odd found and suspended (by the odd, its bet type, or its event)
  MatchedClosed = 3, // odd found and closed (by the odd, its bet type, or its event)
  UnmatchedSuspended = 4, // odd missing from payload, but bet type/event says suspended
  UnmatchedClosed = 5, // odd missing from payload, but bet type/event says closed
  Unchanged = 6, // odd missing from payload and no closure signal — leave as-is
}

export const enum BetBuilderRemovalConditionEnum {
  NoRemoval = 1, // bet is unaffected, keep it in the combo
  RemoveWholeEvent = 2, // event itself suspended/closed — the combo can't survive
  RemoveLegOnly = 3, // only this leg's odd/bet type suspended/closed — drop just the leg
}

export const enum Cultures {
  EN = "en",
  ES = "es",
  FR = "fr",
  DE = "de",
  IT = "it",
  PT = "pt",
  RU = "ru",
  ZH = "zh",
  JA = "ja",
  AR = "ar",
  HE = "he",
}

export const enum CulturesWithLocale {
  EN_US = "en-US", // English (US)
  EN_GB = "en-GB", // English (UK)
  FR_FR = "fr-FR", // French (France)
  FR_CA = "fr-CA", // French (Canada)
  ES_ES = "es-ES", // Spanish (Spain)
  ES_MX = "es-MX", // Spanish (Mexico)
  DE_DE = "de-DE", // German (Germany)
  IT_IT = "it-IT", // Italian (Italy)
  PT_PT = "pt-PT", // Portuguese (Portugal)
  PT_BR = "pt-BR", // Portuguese (Brazil)
  RU_RU = "ru-RU", // Russian (Russia)
  ZH_CN = "zh-CN", // Chinese (Simplified)
  ZH_TW = "zh-TW", // Chinese (Traditional)
  JA_JP = "ja-JP", // Japanese (Japan)
  AR_SA = "ar-SA", // Arabic (Saudi Arabia)
  AR_EG = "ar-EG", // Arabic (Egypt)
  HE_IL = "he-IL", // Hebrew (Israel)
  SW_KE = "sw-KE", // Swahili (Kenya)
  SW_TZ = "sw-TZ", // Swahili (Tanzania)
  AM_ET = "am-ET", // Amharic (Ethiopia)
  NY_MW = "ny-MW", // Chichewa (Malawi)
}

// Bonus Type Constants
export enum BonusType {
  WinBoost = 10,
  RefundBonus = 11,
  FreeBet = 12,
}

export enum BonusCategory {
  WIN_BOOST = "WINBOOST",
  REFUND_BONUS = "REFUND",
  FREE_BET = "FREEBET",
  UNKNOWN = "UNKNOWN",
}

// Bonus Status Constants
export enum BonusStatus {
  Inactive = 4,
  Cancelled = 5,
  Active = 8,
}

export const enum WinBoostEligibilityCondition {
  Eligible                   = "ELIGIBLE",
  NoActiveBoost              = "NO_ACTIVE_BOOST",
  FreeBetActive              = "FREE_BET_ACTIVE",
  NoStake                    = "NO_STAKE",
  InsufficientTotalOdds      = "INSUFFICIENT_TOTAL_ODDS",
  InsufficientMinOddPerRow   = "INSUFFICIENT_MIN_ODD_PER_ROW",
  InsufficientMinStakeCombo  = "INSUFFICIENT_MIN_STAKE_COMBO",
  InsufficientMinStakeSingle = "INSUFFICIENT_MIN_STAKE_SINGLE",
}

export const enum Currency {
  USD = "USD", // US Dollar (ID: 1)
  UGX = "UGX", // Ugandan Shilling (ID: 2)
  ETB = "ETB", // Ethiopian Birr (ID: 17)
  RWF = "RWF", // Rwandan Franc (ID: 28)
  ZMW = "ZMW", // Zambian Kwacha (ID: 100)
  // Additional commonly supported currencies
  EUR = "EUR", // Euro
  GBP = "GBP", // British Pound
  KES = "KES", // Kenyan Shilling
  TZS = "TZS", // Tanzanian Shilling
  BWP = "BWP", // Botswana Pula
  ZAR = "ZAR", // South African Rand
  NGN = "NGN", // Nigerian Naira
  GHS = "GHS", // Ghanaian Cedi
  XOF = "XOF", // West African CFA Franc
  XAF = "XAF", // Central African CFA Franc
  MZN = "MZN", // Mozambican Metical
  AOA = "AOA", // Angolan Kwanza
  MWK = "MWK", // Malawian Kwacha
  SZL = "SZL", // Swazi Lilangeni
  LSL = "LSL", // Lesotho Loti
  NAD = "NAD", // Namibian Dollar
  BIF = "BIF", // Burundian Franc
  DJF = "DJF", // Djiboutian Franc
  ERN = "ERN", // Eritrean Nakfa
  SOS = "SOS", // Somali Shilling
  SSP = "SSP", // South Sudanese Pound
  SDG = "SDG", // Sudanese Pound
  EGP = "EGP", // Egyptian Pound
  LYD = "LYD", // Libyan Dinar
  TND = "TND", // Tunisian Dinar
  DZD = "DZD", // Algerian Dinar
  MAD = "MAD",
}

export const enum Layout {
  Mobile = "mobile",
  Desktop = "desktop",
  Tablet = "tablet",
}

export const enum KeyboardMode {
  Keyboard = "keyboard",
  Chips = "chips",
  All = "all",
}

export const enum PlaceBetValidationError {
  None = "None",
  UserLocked = "UserLocked",
  MaxSelectionsExceeded = "MaxSelectionsExceeded",
  StakeNotMetCombo = "StakeNotMetCombo",
  StakeNotMetSingle = "StakeNotMetSingle",
  StakeBelowMin = "StakeBelowMin",
  StakeAboveMax = "StakeAboveMax",
  NoBalance = "NoBalance",
  InsufficientBalance = "InsufficientBalance",
}

export const enum SourcePage {
  UNKNOWN = 'unknown',
  EVENT_PAGE = 'event-page',
  BET_BUILDER_TAB = 'bet-builder-tab',
  EVENT_LOBBY = 'event-lobby',
  POPULAR_EVENT_CAROUSEL = 'popular-event-carousel'
}

export const enum ShareChannelEnum {
  WhatsApp = "WhatsApp",
  Telegram = "Telegram",
  Facebook = "Facebook",
  CopyLink = "CopyLink",
}

export const enum BookingCodeInputTypeEnum {
  Barcode = "Barcode",
  BookingCode = "BookingCode",
}

export const enum BetChangeRowCondition {
  OddsOnly = 1, // odds changed, stake did not
  StakeOnly = 2, // stake changed, odds did not
  Both = 3, // odds and stake both changed
  None = 4, // neither changed
}